// Atstumas tarp dviejų taškų kilometrais (Haversine formulė)
export function haversine(lat1, lng1, lat2, lng2) {
  const R = 6371
  const dLat = ((lat2 - lat1) * Math.PI) / 180
  const dLng = ((lng2 - lng1) * Math.PI) / 180
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
    Math.cos((lat2 * Math.PI) / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2)
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

// ─── DARBO LAIKAS ─────────────────────────────────────────────────────────────
// Trys būsenos, ne dvi:
//   visada_atvira = true          → pieva, ežeras, piliakalnis. Vartų nėra.
//   darbo_laikas yra              → skaitom ŠIANDIENOS dieną
//   darbo_laikas tuščias          → nepatikrinta. Nemeluojam — sakom tiesiai.
//
// ⚠️ 2026-09-20: senoji versija imdavo PIRMĄ laiko intervalą eilutėje ir
// taikydavo jį visoms septynioms dienoms. Medininkų pilis pirmadienį uždaryta,
// bet kodas pačiumpa antradienio 10:00–18:00 ir sako „atvira".

const DIENOS = [
  'sekmadienis', 'pirmadienis', 'antradienis', 'trečiadienis',
  'ketvirtadienis', 'penktadienis', 'šeštadienis',
]

export function vietosStatusas(vieta, dabar = new Date()) {
  if (!vieta) return null

  if (vieta.visada_atvira) {
    return { tipas: 'visada', atvira: true, tekstas: 'atvira visada' }
  }

  const dl = vieta.darbo_laikas
  if (!dl) {
    return { tipas: 'nezinoma', atvira: null, tekstas: 'darbo laikas nepatikrintas' }
  }

  // Savaitės formatas: „pirmadienis: Uždaryta; antradienis: 10:00–18:00; ..."
  const diena = DIENOS[dabar.getDay()]
  const zemas = dl.toLowerCase()
  let segmentas = dl
  if (zemas.includes(diena)) {
    const rastas = dl.split(';').find(d => d.toLowerCase().includes(diena))
    if (rastas) segmentas = rastas
  }

  if (/uždaryt/i.test(segmentas)) {
    return { tipas: 'uzdaryta', atvira: false, tekstas: 'šiandien uždaryta' }
  }
  if (/24\s*val|visą\s*parą/i.test(segmentas)) {
    return { tipas: 'atvira', atvira: true, tekstas: 'atvira visą parą' }
  }

  const m = segmentas.match(/(\d{1,2}):(\d{2})\s*[-–—]\s*(\d{1,2}):(\d{2})/)
  if (!m) {
    return { tipas: 'nezinoma', atvira: null, tekstas: 'darbo laikas nepatikrintas' }
  }

  const dabarMin = dabar.getHours() * 60 + dabar.getMinutes()
  const nuo = parseInt(m[1], 10) * 60 + parseInt(m[2], 10)
  const iki = parseInt(m[3], 10) * 60 + parseInt(m[4], 10)

  if (dabarMin >= nuo && dabarMin < iki) {
    return { tipas: 'atvira', atvira: true, tekstas: `atvira iki ${m[3]}:${m[4]}` }
  }
  return {
    tipas: 'uzdaryta',
    atvira: false,
    tekstas: dabarMin < nuo ? `atsidaro ${m[1]}:${m[2]}` : 'šiandien jau uždaryta',
  }
}
